import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import PDPAlertBar from 'components/consumer/PDP/PDPAlertBar';
import useSetPdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/useSetPdpSelectedCustomizerTab';
import { PDP_CUSTOMIZE_TAB_ID } from 'commons/constants';
const PDPSelectionAlert = t0 => {
  const $ = _c(6);
  const {
    selectionValidity: t1
  } = t0;
  const selectionValidity = t1 === undefined ? "" : t1;
  const setPdpSelectedCustomizerTab = useSetPdpSelectedCustomizerTab();
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span>Unavailable for ready to ship.</span>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== selectionValidity || $[2] !== setPdpSelectedCustomizerTab) {
    t3 = selectionValidity === "invalid" ? <span> Get this by{" "}<button type="button" className="font-bold underline [background:none] border-0" onClick={() => setPdpSelectedCustomizerTab(PDP_CUSTOMIZE_TAB_ID)}>going custom</button>.</span> : null;
    $[1] = selectionValidity;
    $[2] = setPdpSelectedCustomizerTab;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <PDPAlertBar type="error">{t2}{t3}</PDPAlertBar>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
PDPSelectionAlert.propTypes = {
  selectionValidity: PropTypes.string
};
export default PDPSelectionAlert;